import pensionStatementSettingsForm from "form/modal/pensionStatementSettings";
import { FORM_EDIT_CLIENT_STATEMENT_SETTINGS } from "../constants";
import { isElectronicCommunicationSet } from "../selectors";

export const PensionStatementSettingsForm = pensionStatementSettingsForm.createInPageContainer(
    FORM_EDIT_CLIENT_STATEMENT_SETTINGS,
    isElectronicCommunicationSet,
);
